import React, { useEffect, useState } from "react";
import { message, Layout, Modal, } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import logo from "./../assets/img/BAbianco.png"
import { checkTokenOperatore } from "../services/api";

const { Content, Header } = Layout;
const { innerWidth, innerHeight } = window;

const CheckOperatore = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  let { token } = useParams();

  const recuperaVerifica = () => {
    setLoading(true);
    checkTokenOperatore(token)
      .then((response) => {
        localStorage.setItem('tokenOperatore', token);
        localStorage.setItem('nomeOperatore', response.utente);
        localStorage.setItem('matricolaOperatore', response.matricola);
        localStorage.setItem('nomeFiliale', response.numero_filiale + ' - '+response.filiale);
        navigate('/home');
      })
      .catch((error) => {
        if(error == 'FIL')
        {
          Modal.warning({
            title: 'Errore CSE',
            content: 'Esegui il login sulla Filiale 70 per poter usare Conto Online Operatore',
            okText:"Torna alla Homepage",
            onOk: () => { 
              navigate('/homepage'); 
              localStorage.removeItem('tokenOperatore');
              localStorage.removeItem('nomeOperatore');
              localStorage.removeItem('matricolaOperatore');
              localStorage.removeItem('nomeFiliale');
  
            },
            closable: false,
            maskClosable: false
          });
        }
        else
        {
          Modal.warning({
            title: 'Il link è scaduto',
            content: 'Riapri l\'applicativo da SiWeb',
            okText:"Torna alla Homepage",
            onOk: () => { 
              navigate('/homepage'); 
              localStorage.removeItem('tokenOperatore');
              localStorage.removeItem('nomeOperatore');
              localStorage.removeItem('matricolaOperatore');
  
            },
            closable: false,
            maskClosable: false
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (token) {
      recuperaVerifica();
    }
  }, [])



  return (
    <Layout style={{ height: '100vh', backgroundColor: 'white' }}>
      <Header style={{ backgroundColor: '#003897' }}>
        <img src={logo} alt="Banco Azzoaglio" width={160} style={{ padding: 5, marginBottom: 5 }} />
      </Header>
      <Content>
        {loading &&
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <LoadingOutlined style={{ fontSize: "34px", color: "rgb(0, 56, 151)", marginTop:40 }} />
          </div>
        }
      </Content>
    </Layout >

  );
};

export default CheckOperatore;
